module.exports = __webpack_public_path__ + "img/评估.5636f97a.png";